import { getClassroomDates, getClassroomIdByUserId, getConfigurationStatus, getDayCourses } from '@webapps/business';
import { useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { Button, Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import QRScannerModal from "../Dashboard/Components/School/QRScannerModal";

import Planning from './components/Planning';
import PlanningManagerRight from './components/PlanningManagerRight';
import { CalendarProvider } from 'pages/school/ClassesPage/ClassesDetail/Stores/CalendarProvider';
import ActivityPlanning from './components/ActivityPlanning';
import { planningColorsText } from 'pages/school/ClassesPage/Classes/colors/planningColors';
import { useCalendar } from 'pages/school/ClassesPage/ClassesDetail/Stores/CalendarProvider';
import DashboardCalendar from '../Dashboard/Components/School/DashboardCalendar';
import ScheduleRows from 'pages/school/ClassesPage/ClassesDetail/Components/ScheduleRows';
import { hoursSchedule as hours } from 'config/constants';
import { format, parseISO } from 'date-fns';
import { getEmptyIntervals } from 'pages/school/ClassesPage/ClassesDetail/utils/services';
import { fr } from 'date-fns/locale';
import axios from "axios";

const { NX_REST_API } = process.env;

// Composant interne pour accéder au contexte CalendarProvider
const PlanningContent = () => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const [isQRScannerOpen, setIsQRScannerOpen] = useState(false);
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const { state, dispatch } = useCalendar();
  const [holidays, setHolidays] = useState([]); // État pour les jours fériés
  const [periods, setPeriods] = useState([]);
  const [planning, setPlanning] = useState([]);

  const { data: classroomId } = useQuery(getClassroomIdByUserId, {
    key: 'classroomIdMinimizePlanning student',
    variables: { id: idUser },
    enabled: !!idUser
  })

  const handleScanQRCode = (result) => {

    // Ici vous pouvez ajouter la logique pour gérer l'émargement
    setIsQRScannerOpen(false);
  };

  const handleVisibleCategory = (categoryKey) => {
    dispatch({ type: "TOGGLE_CATEGORY_VISIBILITY", payload: categoryKey });
  };



  const { data: classroomDates = {}, isLoading: isLoadingClassroomDates } = useQuery(getClassroomDates, {
    key: ['classroomDates student', date],
    variables: { classroomId: classroomId?.classroomId },
    enabled: !!classroomId?.classroomId,
  });

  const formattedStartDate = classroomDates?.startDate ? format(new Date(classroomDates?.startDate), "yyyy-MM-dd") : null;
  const formattedEndDate = classroomDates?.endDate ? format(new Date(classroomDates?.endDate), "yyyy-MM-dd") : null;

  // const { data: configurationStatus, isLoading: isLoadingConfigurationStatus, refetch: refetchConfigurationStatus } = useQuery(getConfigurationStatus, {
  //   key: ['configurationStatus student', date],
  //   variables: { id: classroomId?.classroomId, startDate: formattedStartDate, endDate: formattedEndDate },
  //   enabled: Boolean(!isLoadingClassroomDates && formattedStartDate && formattedEndDate),
  // });



  // const allConfigurationStatus = configurationStatus ? [...configurationStatus?.configured, ...configurationStatus?.notConfigured] : [];

  // const getConfigurationOfDate = (date) => {



  //   return allConfigurationStatus.find(configuration => configuration.date === date);
  // }

  const { data: courses = [], isLoading: isLoadingCourses, refetch: refetchCourses } = useQuery(getDayCourses, {
    key: ['dayCourses', date],
    variables: { date: date, classroomId: classroomId?.classroomId },
    enabled: !!classroomId?.classroomId,
  });

  // const dateConfigurationStatus = getConfigurationOfDate(date);

  useEffect(() => {
    refetchCourses();
  }, [date]);



  // Transformer les données du state en format pour ActivityPlanning
  const activities = Object.entries(state.categoryTotals).map(([key, value]) => {


    return {
      key: key, // Garder la clé originale comme identifiant
      label: key === "FERIES" ? "Jours fériés" : key === "VACANCES" ? "Vacances" : `En ${key.toLocaleLowerCase()}`,
      color: planningColorsText[key],
      day: value.days,
      hour: value.hours,
    }
  });
  console.log("🚀 ~ activities ~ state:", state)


  const visibleMap = Object.entries(state.categoryTotals).reduce((acc, [key, value]) => {
    acc[key] = value.visible; // Utiliser directement la clé
    return acc;
  }, {});

  const firstClassHour = hours[0];
  const lastClassHour = hours[hours.length - 1];

  const emptyIntervals = getEmptyIntervals(courses, firstClassHour, lastClassHour);

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  const stringDate = capitalize(format(new Date(date), "eeee d MMMM yyyy", { locale: fr }));

  const onClickDate = (date) => {

    const formattedDate = format(date, "yyyy-MM-dd");
    setDate(formattedDate);
  }

  const normalizeDate = (date) => {
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0);
    return normalized;
  };

  const getDaysBetweenDates = () => {
    if (!formattedStartDate || !formattedEndDate) return [];
    const days = [];
    let currentDate = normalizeDate(formattedStartDate);
    const end = normalizeDate(formattedEndDate);

    while (currentDate <= end) { // Inclure explicitement la date de fin
      days.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return days;
  };

  const getPeriodTypeForDay = (day) => {
    const normalizedDay = normalizeDate(day);
    const period = periods.find((p) => {
      const start = normalizeDate(parseISO(p.startDate));
      const end = normalizeDate(parseISO(p.endDate)); // Pas besoin d'ajouter 1 jour ici
      return normalizedDay >= start && normalizedDay <= end; // Inclure la date de fin
    });
    return period ? period : null;
  };

  const isHoliday = (day) => {
    if (!holidays || holidays.length === 0) return false; // Vérifie si holidays est vide
    const normalizedDay = normalizeDate(day);

    return holidays.some((holiday) => {
      const holidayDate = normalizeDate(new Date(holiday.date)); // Crée un objet Date à partir de holiday.date
      return holidayDate.getTime() === normalizedDay.getTime();
    });
  };

  const handleSetCategoryTotals = (data) => {


    dispatch({ type: "SET_CATEGORIES_TOTALS", payload: data });
  };

  const calculateCategoryTotals = () => {


    const totals = {
      FORMATION: { days: 0, hours: 0, visible: true },
      ENTREPRISE: { days: 0, hours: 0, visible: true },
      VACANCES: { days: 0, hours: 0, visible: true },
      FERIES: { days: 0, hours: 0, visible: true }, // Ajout pour les jours fériés
    };

    getDaysBetweenDates().forEach((day) => {
      const period = getPeriodTypeForDay(day);
      // if (period) {


      // }

      const periodType = period ? period.type : null;
      const isWeekend = day.getDay() === 6 || day.getDay() === 0; // 6 = samedi, 0 = dimanche
      const isHolidayDay = isHoliday(day);

      if (isHolidayDay) {
        totals.FERIES.days += 1;
        totals.FERIES.hours += 7;
      }

      if ((periodType === "FORMATION" || periodType === "ENTREPRISE") && !isWeekend && !isHolidayDay) {
        totals[periodType].days += 1;
        totals[periodType].hours += period.hoursPerDay; // Chaque jour compte pour 7 heures
      }

      if (periodType === "VACANCES") {
        totals.VACANCES.days += 1;
        totals.VACANCES.hours += 7;
      }
    });


    handleSetCategoryTotals(totals);
  };

  useEffect(() => {
    // Ne calculer qu'une seule fois quand les données sont chargées
    if (periods.length > 0 && formattedStartDate && formattedEndDate) {
      calculateCategoryTotals();
    }
  }, [periods, holidays]); // Retrait des dates formattées des dépendances

  const fetchHolidays = async () => {

    try {

      const response = await axios.get(`${NX_REST_API}/schools/module/planning/holiday`);

      setHolidays(response.data); // Stocke les jours fériés dans l'état

    } catch (error) {

      console.error("Error fetching holidays:", error);
    }
  };

  const fetchPlanning = async () => {

    try {
      const response = await axios.get(
        `${NX_REST_API}/schools/module/classrooms/${classroomId?.classroomId}/planning`
      );



      setPlanning(response.data);
      setPeriods(response.data.periods || []);
    } catch (error) {
      console.error("Error fetching planning:", error);
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      await Promise.all([
        fetchHolidays(),
        fetchPlanning()
      ]);
    };
    fetchAllData();
  }, [classroomId]);

  return (
    <div className={classes.container}>
      {/* Colonne de gauche : Planning */}
      <div className={classes.leftColumn}>
        <ActivityPlanning
          activities={activities}
          onToggle={handleVisibleCategory}
          visibleMap={visibleMap}
        />
        <DashboardCalendar
          classroomId={classroomId?.classroomId}
          onOpenAbsenceModal={() => { }}
          onClickDate={onClickDate}
          daySelected={date}
          display={{
            qrCodeButton: false,
            declareAbsenceButton: false,
            seePlanningButton: false,
          }}
          from="student-planning"
        />
      </div>

      <div className={classes.rightColumn}>
        <div className={cx(classes.leftColumnTitle, global.headerTitle)}>
          {stringDate}
        </div>

        <ScheduleRows
          hours={hours}
          courses={courses}
          emptyIntervals={emptyIntervals}
          onSelectInterval={() => { }}
          editCourse={() => { }}
          resetEmptyCoursesSignal={0}
          canModify={false}
          from="student"
          disabledConfig={
            courses.length > 0
              ? { disabled: false, message: "" }
              : { disabled: true, message: "Aucun cours n'a été configuré pour cette date" }
          }
        />
      </div>

      <QRScannerModal
        open={isQRScannerOpen}
        onClose={() => setIsQRScannerOpen(false)}
        onScan={handleScanQRCode}
      />
    </div>
  );
};

// Composant principal avec CalendarProvider au niveau global
const PlanningStudent = () => {
  return (
    <CalendarProvider>
      <PlanningContent />
    </CalendarProvider>
  );
};

const styles = ({ spacing }) => ({
  container: {
    width: "100%",
    height: "100%",
    padding: "50px",
    display: "flex",
    flexDirection: "row",
    gap: 30,
    boxSizing: "border-box",
    '@media (max-width: 1110px)': {
      flexDirection: 'column',
      gap: 0,
    },
  },
  leftColumn: {
    width: "400px",
    flexShrink: 0,
    flexGrow: 0,
    display: "flex",
    flexDirection: "column",
    gap: spacing(2),
    position: "sticky",
    top: 50,
    alignSelf: "flex-start",
    height: "fit-content",
    zIndex: 2,
    '@media (max-width: 1110px)': {
      width: '100%',
      order: 1,
      position: 'static',
      backgroundColor: 'white',
      borderRadius: "16px 16px 0px 0px",
      padding: "20px 20px 0px 20px",
      gap: "16px",
    },
  },
  rightColumn: {
    flex: 1,
    width: 0, // Force le flex à calculer la largeur
    backgroundColor: "white",
    borderRadius: "10px",
    height: "fit-content",
    overflow: "hidden", // Évite le débordement
    '@media (max-width: 1110px)': {
      width: '100%',
      order: 2,
      borderRadius: "0px 0px 16px 16px",
      paddingBottom: "20px",
    },
  },
  headerContainer: {
    marginBottom: spacing(1),
    // padding: spacing(2),
  },
  emergerButton: {
    backgroundColor: "#152652",
    color: "white",
    width: "100%",
    "&:hover": {
      backgroundColor: "#0f1c3d",
    },
  },
  leftColumnTitle: {
    // marginBottom: spacing(2),
    padding: spacing(2),
  },
});

export default PlanningStudent;
